import { api } from './api';

export interface AuditLogEntry {
  id: string;
  timestamp: string;
  user_id?: string | null;
  username?: string | null;
  ip_address?: string | null;
  user_agent?: string | null;
  action?: string | null;
  resource_type?: string | null;
  resource_id?: string | null;
  old_value?: any;
  new_value?: any;
  details?: any;
  success?: boolean;
  error_message?: string | null;
}

export interface AuditListResponse {
  logs: AuditLogEntry[];
  total: number;
  page: number;
  per_page: number;
  pages: number;
  has_next: boolean;
  has_prev: boolean;
}

export type AuditListParams = {
  action?: string;
  resource_type?: string;
  resource_id?: string;
  user_id?: string;
  username?: string;
  success?: 'true' | 'false';
  start_date?: string; // ISO
  end_date?: string; // ISO
  page?: number;
  per_page?: number;
};

export const auditApi = {
  list: async (params: AuditListParams): Promise<AuditListResponse> => {
    const res = await api.get('/api/v1/audit/', { params });
    return res.data as AuditListResponse;
  },
  summary: async (days: number = 7): Promise<any> => {
    const res = await api.get('/api/v1/audit/summary', { params: { days } });
    return res.data;
  },
  appendEvent: async (event: {
    action: string;
    resource_type: string;
    resource_id: string;
    details?: any;
    old_value?: any;
    new_value?: any;
    success?: boolean;
    error_message?: string;
  }): Promise<any> => {
    const res = await api.post('/api/v1/audit/events', event);
    return res.data;
  },
};


